import React from 'react';
import { GroupBase, SelectComponentsConfig, SingleValueProps, components as ReactSelectComponents } from 'react-select';

import styles from '../select.module.scss';

interface IProps<SOption, IsMulti extends boolean, Group extends GroupBase<SOption>> {
  dataTest: string,
  isSelectMenuOpen: boolean,
  components?: SelectComponentsConfig<SOption, IsMulti, Group>,
  isSelectedPlaceholderVisibleWhenOpen?: boolean,
  selectedPlaceholderWhenOpen?: string,
  ownProps: SingleValueProps<SOption, IsMulti, Group>,
}

const SingleValue = <SOption, IsMulti extends boolean, Group extends GroupBase<SOption>>({
  dataTest,
  components = {},
  isSelectedPlaceholderVisibleWhenOpen,
  selectedPlaceholderWhenOpen,
  isSelectMenuOpen,
  ownProps: {
    children,
    ...otherProps
  },
}: IProps<SOption, IsMulti, Group>) => {
  const dataTestAttr = `${ dataTest }_selected`;
  const style = otherProps.getStyles('singleValue', { ...otherProps, children });
  const classes = otherProps.getClassNames('singleValue', { ...otherProps, children });

  if (components?.SingleValue) {
    const { SingleValue: SingleValueComponent } = components;

    return (
      <div
        data-test={ dataTestAttr }
        className={ classes }
        style={ style as React.CSSProperties }
      >
        <SingleValueComponent { ...otherProps }>{ children }</SingleValueComponent>
      </div>
    );
  }

  return (
    <div
      data-test={ dataTestAttr }
      className={ classes }
      style={ style as React.CSSProperties }
    >
      <ReactSelectComponents.SingleValue { ...otherProps }>
        {
          isSelectedPlaceholderVisibleWhenOpen && isSelectMenuOpen
            ? (<span className={ styles.placeholder }>{ selectedPlaceholderWhenOpen }</span>)
            : children
        }
      </ReactSelectComponents.SingleValue>
    </div>
  );
};

export default SingleValue;
